module.exports = __webpack_public_path__ + "media/images/pc/icon-star-blank-49dba4d6ad99c7357187018dc6a08466.png";